import { appConfig } from './local';

export const FEATURE_KEYS = {
  IS_ACH_MANDATE_ENABLED: 'isAchMandateEnabled',
};

export const featureMap = new Map(Object.entries(appConfig?.features) || {});

export default featureMap;
